import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { notify, SUCCESS_NOTIFY, DANGER_NOTIFY } from "../../../control-core/util/notify.util";
import { StateService } from '@uirouter/core';
import { TranslateService } from "@ngx-translate/core";
import { IRadioElement } from "../../../control-core/shared/radio/radio.component";
import { ErrorService } from "../../../control-core/services/error.service";
import * as cloneDeep from 'lodash/cloneDeep';
import { ValidatorService } from "../../../control-core/services/validator-service";
import { AppConfigService } from "../../../control-core/services/app-config.service";

import { SelectPaisesService } from '../../../control-core/services/select-paises.service';
import { SelectDepartamentosService } from '../../../control-core/services/select-departamentos.service';
import { SelectCiudadesService } from '../../../control-core/services/select-ciudades.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html'
})


export class RegistroComponent implements OnInit {

  modoIdentificar: boolean = false;
  inputIdentificar = {hasError: false, errorText: "", value: '', tipo: 'idbox'};
  identificarOptions: IRadioElement[];
  cuestionarioPreguntas = [];
  cuestionarioRespuestas = {};
  registrando: boolean = false;
  identificando: boolean = false;
  registroForm: FormGroup = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/), this._validatorService.nombreApellidoFormValidator]),
    lastname: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/),  this._validatorService.nombreApellidoFormValidator]),
    identificacion: new FormControl('', [Validators.required]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
    telefono: new FormControl('', [Validators.required, this._validatorService.soloNumerosFormValidator]),
    tipoidentificacion: new FormControl('', [Validators.required]),
    gepais_id: new FormControl ('',[Validators.required]),
    gedepartamento_id: new FormControl ('',[Validators.required]),
    geciudade_id: new FormControl ('',[Validators.required]),
    direccion_cliente: new FormControl('', [Validators.required]),
  });
  logoApp;

  tipoidentificacionOptions = [
    { value: 'CC', label: 'CC' },
    { value: 'CE', label: 'CE' },
    { value: 'Pasaporte', label: 'Pasaporte'},
    { value: 'NIT', label: 'NIT'},
  ];

   //paises
   paises: any [];
   departamentos: any[];
   ciudades: any[];
   filteredDepartamentos: any[];
   isLoading: boolean = false;
   selectedPaisId: string;
   selectedDeptoid:string;
   selectedCiudadid:string;

  // Agrega un método para aplicar las validaciones según el tipo de identificación seleccionado
  applyValidationBasedOnTipoIdentificacion(): void {
    const identificacionControl = this.registroForm.get('identificacion');
    const tipoIdentificacion = this.registroForm.get('tipoidentificacion').value;
  
    identificacionControl.clearValidators(); // Clear existing validators first
    identificacionControl.updateValueAndValidity(); // Update validation status
  
    if (tipoIdentificacion === 'CC') {
      identificacionControl.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]+$/),
        this._validatorService.ccValidation,
        this._validatorService.symbolValidation,
      ]);
    } else if (tipoIdentificacion === 'CE' || tipoIdentificacion === 'Pasaporte') {
      identificacionControl.setValidators([
        Validators.required,
        this._validatorService.cePasaporteValidation,
        this._validatorService.symbolValidation,
      ]);
    } else if (tipoIdentificacion === 'NIT') {
      identificacionControl.setValidators([
        Validators.required,
        this._validatorService.nitValidation,
        this._validatorService.symbolValidation,
      ]);
    }
  
    identificacionControl.updateValueAndValidity(); // Apply new validators
  }

  

  constructor(private _renderer: Renderer2,
              private _http: HttpClient,
              private _state: StateService,
              private _translate: TranslateService,
              private _validatorService: ValidatorService,
              private _errorService: ErrorService,
              private _appConfigService: AppConfigService,
              private selectPaisesService: SelectPaisesService,
              private selectDepartamentosService: SelectDepartamentosService,
              private selectCiudadesService:SelectCiudadesService,
              ) {
  }

  ngOnInit() {
    this._renderer.addClass(document.body, 'signup-page');
    this.identificarOptions = [
      {value: 'idbox', label: 'IDBOX'},
      {value: 'email', label: 'EMAIL'},
      {value: 'telefono', label: 'TELEFONO'},
    ];
    this.loadLogo();
    this.getPaises();
    this.getDepartamentos();
    this.applyValidationBasedOnTipoIdentificacion();    
  }

  registrar() {
    if (this.registroForm.valid) {
      this.registrando = true;
      let dataRequest = this.registroForm.value;

      dataRequest['cuestionario'] = cloneDeep(this.cuestionarioRespuestas);
      dataRequest['acepta_terminos_condiciones'] = 1;
      dataRequest['dominio'] = window.location.hostname;
      this.limpiarRespuestasQuestionario();

      this._http.post(`${CONTROL_APP_CONST.API_URL}registrocliente`, dataRequest)
          .subscribe(
              (response) => {
                this.registrando = false;
                notify(this._translate.instant("CLIENTE_REGISTRADO_REVISE_CORREO"), SUCCESS_NOTIFY);
                this._state.go("login", {}, {reload: true});
              },
              (resError) => {
                this.registrando = false;
                if (resError.error.res && resError.error.res == "requiereform") {
                  $('#questionsModal').modal('show');
                  this.limpiarRespuestasQuestionario();
                  this.cuestionarioPreguntas.splice(0, this.cuestionarioPreguntas.length);
                  Object.keys(resError.error.data).forEach(key => {
                    this.cuestionarioRespuestas[key] = '';
                    this.cuestionarioPreguntas.push(
                        {
                          name: key,
                          data: resError.error.data[key].map((value) => {
                            return {value: value, label: value}
                          })
                        }
                    );
                  });
                } else {
                  this._errorService.manejaError(resError);
                }
              }
          )
    }


  }

  loadLogo(){
    if (localStorage.getItem(CONTROL_APP_CONST.URL_LOGO_APP_NAME) == null ) {
      this._appConfigService.loadAgencyLogosAsync().then(res => {
        if (res['has_logo']) {
          this.logoApp = res['url_logo_agencia'];
        }else{
          this.logoApp = CONTROL_APP_CONST.URL_LOGO_APP;
        }
        localStorage.setItem(CONTROL_APP_CONST.URL_LOGO_APP_NAME, this.logoApp);
      }).catch( error => {
        console.log(error);
        notify("Error al cargar los logos", DANGER_NOTIFY);
      });
    }else{
      this.logoApp = localStorage.getItem(CONTROL_APP_CONST.URL_LOGO_APP_NAME);
    }
  }

  identificar() {
    if (this.inputIdentificar.value != '') {
      this.identificando = true;
      this._http.get(`${CONTROL_APP_CONST.API_URL}consultacliente`,
          {params: {tipo: this.inputIdentificar.tipo, data: this.inputIdentificar.value}})
          .subscribe(() => {
                notify(this._translate.instant("CLIENTE_REGISTRADO_REVISE_CORREO"), SUCCESS_NOTIFY);
                this._state.go("login", {}, {reload: true});
                this.identificando = false;
              },
              error => {
                this._errorService.manejaError(error);
                this.identificando = false;
              });

    } else {
      this.inputIdentificar.hasError = true;
      this.inputIdentificar.errorText = 'CAMPO_REQUIRED_LABEL';
    }
  }

  enviarRespuesta() {
    this.registrar();
    $('#questionsModal').modal('hide');
  }

  limpiarRespuestasQuestionario() {
    for (let prop in this.cuestionarioRespuestas) {
      if (this.cuestionarioRespuestas.hasOwnProperty(prop)) {
        delete this.cuestionarioRespuestas[prop];
      }
    }
  }

  getPaises() {
    this.selectPaisesService.getPaisesControlBox().subscribe(
      (data) => {
        this.paises = data;
      },
      (error) => {
        console.error('Error al obtener la lista de países', error);
      }
    );
  }

  getDepartamentos() {
    this.selectDepartamentosService.getDepartamentosControlBox().subscribe(
      (data) => {
        this.departamentos = data;
        // Al principio, muestras todos los departamentos sin filtrar.
        this.filteredDepartamentos = data;
      },
      (error) => {
        console.error('Error al obtener la lista de países', error);
      }
    );
  }

  onPaisSelectionChange(selectedPaisId: string) {
    this.selectedPaisId = selectedPaisId;
    this.filteredDepartamentos = this.departamentos.filter(
      (departamento) => departamento.pais.id === selectedPaisId
    );
    this.registroForm.patchValue({
      gepais_id: selectedPaisId,
    });
  }

  onDepartamentSelectedChange(selectedDeptoid:string){
    this.selectedDeptoid = selectedDeptoid;
    this.isLoading = true;
    this.selectCiudadesService.getCiudadesControl(selectedDeptoid).subscribe(
      (data) => {
        this.ciudades = data
        this.isLoading = false;
        this.registroForm.patchValue({
          gedepartamento_id: selectedDeptoid,
        });
      },(error)=>{
        console.log("Error al traer ciudades", error)
      }
    )
  }

  onCiudadSelectedChange(ciudadId: string) {
    this.selectedCiudadid = ciudadId;
    this.registroForm.patchValue({
      geciudade_id: ciudadId,
    });
  }


  ngOnDestroy() {
    this._renderer.removeClass(document.body, 'signup-page');
  }

}



// WEBPACK FOOTER //
// ./src/app/control-app/views/registro/registro.component.ts